const getters = {
  sidebar: state => state.app.sidebar,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  access_token: state => state.user.access_token,
  refresh_token: state => state.user.refresh_token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  deptName: state => state.user.deptName,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  permission_routes: state => state.permission.routes
}
export default getters
